import React from 'react';
import { School } from '../types';
import { getSchoolColour, getContrastTextColor, getSchoolShortName } from '../utils/schoolUtils';

interface SchoolBadgeProps {
  school?: School | { name?: string; colour?: string; color?: string; type?: string } | null;
  schoolName?: string;
  size?: 'xs' | 'sm' | 'md' | 'lg';
  short?: boolean;
  className?: string;
  showDot?: boolean;
  truncateMaxWidth?: string; // e.g. "max-w-[140px]"
}

export const SchoolBadge: React.FC<SchoolBadgeProps> = ({
  school,
  schoolName,
  size = 'sm',
  short = false,
  className = '',
  showDot = false,
  truncateMaxWidth
}) => {
  const resolvedName = school?.name || schoolName || 'Unassigned School';
  const displayName = short ? getSchoolShortName(resolvedName) : resolvedName;
  const bgColour = getSchoolColour(school, resolvedName);
  const textColour = getContrastTextColor(bgColour);

  const sizeClasses = {
    xs: 'px-2 py-0.5 text-[9px]',
    sm: 'px-2.5 py-0.5 text-[10px]',
    md: 'px-3 py-1 text-xs',
    lg: 'px-3.5 py-1.5 text-xs sm:text-sm'
  }[size];

  return (
    <span
      style={{
        backgroundColor: bgColour,
        color: textColour
      }}
      title={resolvedName}
      className={`inline-flex items-center gap-1.5 font-bold rounded-full shadow-2xs select-none transition ${sizeClasses} ${
        truncateMaxWidth ? `${truncateMaxWidth} truncate` : ''
      } ${className}`}
    >
      {showDot && (
        <span
          style={{
            backgroundColor: textColour === '#FFFFFF' ? 'rgba(255,255,255,0.7)' : 'rgba(0,0,0,0.6)'
          }}
          className="w-1.5 h-1.5 rounded-full shrink-0"
        />
      )}
      <span className="truncate">{displayName}</span>
    </span>
  );
};
